module.exports = __webpack_public_path__ + "static/img/70.e2ce7d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/70.jpg
// module id = kNs5
// module chunks = 0